import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { NgZorroAntdModule } from 'ng-zorro-antd';
import { RouterModule } from '@angular/router';
import { AtomFormationTableAttestationFinFormationComponent } from './atom-formation-table-attestation-fin-formation/atom-formation-table-attestation-fin-formation.component';

@NgModule({
	declarations: [AtomFormationTableAttestationFinFormationComponent],
	imports: [
		CommonModule,
		FormsModule,
		TranslateModule,
		NgZorroAntdModule,
		RouterModule,
	],
	exports: [AtomFormationTableAttestationFinFormationComponent],
})
export class FormationModule {}
